import React, { useEffect, useState, useReducer, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  makeStyles,
  Grid,
  Typography,
  Collapse,
  RootRef,
  useMediaQuery,
  useTheme,
  IconButton,
  InputAdornment,
  Box,
  Checkbox,
  List,
  ListItem,
  Icon,
} from "@material-ui/core";
import {
  TextField,
  OptionCard,
  Paper,
  PopUp,
  Loader,
  Button,
} from "../components";
import { AddIcon, ArrowBackIcon } from "../icons";
import { FormValidator } from "../helpers";
import { doctorServices, patientsServices } from "../services";
import { AuthContext, ProductsContext } from "../context";
import { modals } from "../constants";
import { useScroll, useResize } from "../hooks";
import KeyboardArrowRightRoundedIcon from "@material-ui/icons/KeyboardArrowRightRounded";
export default function SampleScreen(props) {
  const { state } = useLocation();
  const { paperGrow, domRef, onScroll } = useScroll();
  const [titleHeight, setTitleHeight] = useState(0);
  const { collapseH } = useResize();
  const classes = useStyles({ paperGrow, titleHeight, collapseH, ...props })();
  const [rut, setRut] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [termsAndCond, setTermsAndCond] = useState(true);
  const [datatermsAndCond, setDataTermsAndCond] = useState([]);
  const [viewTermsAndConds, setViewTermsAndConds] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [indications, setIndications] = useState("");
  const [errors, setErrors] = useState({});
  const [modal, setModal] = useState(false);
  const [modalName, setModalName] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [modalError, setModalError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [quantityToAssign, setQuantityToAssign] = useState(1);
  const { authState, signOut } = useContext(AuthContext);
  const matchesDesktop = useMediaQuery(useTheme().breakpoints.up("md"));
  const history = useHistory();

  const [products, dispatch] = useReducer(
    (myArray, { type, value, quantity }) => {
      switch (type) {
        case "add":
          return [...myArray, value];
        case "remove":
          return myArray.filter((_, index) => index !== value);
        case "updateIsSelect":
          return myArray.map((element) => {
            if (element._id === value._id) {
              //console.log({element})
              return {
                ...element,
                isSelect: !element.isSelect,
              };
            }
            return { ...element };
          });
        case "updateQuantity":
          return myArray.map((element, index) => {
            if (element._id === value._id) {
              console.log({ element, value });
              return {
                ...element,
                quantityToAssign: quantity,
              };
            }
            return { ...element };
          });
        default:
          return myArray;
      }
    },
    []
  );

  useEffect(() => {
    const { products: productsList } = state;
    //console.log({user: authState.user});
    productsList.forEach((element) => {
      dispatch({
        type: "add",
        value: {
          ...element,
        },
      });
    });
  }, [dispatch, state, authState]);

  useEffect(() => {
    const getDoctorSignedConsents = async () => {
      const { status, response } = await doctorServices.getDoctorSignedConsents(
        {
          token: authState.token,
          _id: authState.user.doctor._id,
        }
      );
      if (status === 200) {
        const productsSelectedLabId = state.products.reduce((acc, curr) => {
          if (curr.isSelect) return [...acc, curr.laboratoryId];
          else return acc;
        }, []);
        const consentsByProducts = response.reduce((acc, curr) => {
          const {
            currentVersion,
            previousVersion,
            isSigned,
            type,
            laboratoryId,
          } = curr;
          if (
            (!isSigned && productsSelectedLabId.includes(laboratoryId)) ||
            (!isSigned && laboratoryId === null)
          )
            return [...acc, curr.currentVersion];
          return acc;
        }, []);
        setDataTermsAndCond(consentsByProducts);
        // console.log(consentsByProducts);
      }
      // console.log(response);
    };
    getDoctorSignedConsents();
    // console.log(state.products);
  }, [state, authState]);

  useEffect(() => {
    setTitleHeight(document.getElementById("paperTitle").clientHeight);
  }, []);

  let formValidatorArray = [
    {
      field: "rut",
      method: "isEmpty",
      validWhen: false,
      message: "Ingrese su Rut.",
    },
    {
      field: "firstName",
      method: "isEmpty",
      validWhen: false,
      message: "Ingrese su nombre.",
    },
    {
      field: "lastName",
      method: "isEmpty",
      validWhen: false,
      message: "Ingrese sus apellidos.",
    },
  ];

  const onBlur = async (field, value) => {
    const validator = new FormValidator(formValidatorArray);
    let validate = validator.validateField(field, value);
    let aux = { ...errors };
    aux[field] = validate[field];
    setErrors(aux);
  };

  const onSubmit = async () => {
    let names = name.split(" ");
    let firstName = names.splice(0, 1)[0];
    let lastName = names.join(" ");

    let dataToValidate = {
      rut,
      firstName,
      lastName,
    };

    if (!email) {
      dataToValidate.phone = phone;
      formValidatorArray.push(
        {
          field: "phone",
          method: "isEmpty",
          validWhen: false,
          message: "Ingrese numero de teléfono o correo electrónico.",
        },
        {
          field: "phone",
          method: "isLength",
          args: [{ min: 9, max: 9 }],
          validWhen: true,
          message: "Ingrese número de teléfono válido (9 dígitos)",
        }
      );
    }

    if (!phone) {
      dataToValidate.email = email;
      formValidatorArray = [
        ...formValidatorArray,
        {
          field: "email",
          method: "isEmpty",
          validWhen: false,
          message: "Ingrese correo electrónico o numero de teléfono.",
        },
        {
          field: "email",
          method: "isEmail",
          validWhen: true,
          message: "Correo electrónico invalido.",
        },
        // {
        //   field: "phone",
        //   method: "isLength",
        //   args: [{ min: 9, max: 9 }],
        //   validWhen: true,
        //   message: "Ingrese número de teléfono válido (9 dígitos)",
        // },
      ];
    } else {
      dataToValidate.phone = phone;
      formValidatorArray = [
        ...formValidatorArray,
        {
          field: "phone",
          method: "isLength",
          args: [{ min: 9, max: 9 }],
          validWhen: true,
          message: "Ingrese número de teléfono válido (9 dígitos)",
        },
      ];
    }
    const validator = new FormValidator(formValidatorArray);

    const validation = validator.validate(dataToValidate);
    setErrors(validation);
    if (validation.isValid) {
      let productsToAssign = products
        .filter((el) => el.isSelect)
        .map((product) => {
          return {
            _id: product._id,
            quantity: product.quantityToAssign,
          };
        });
      setQuantityToAssign(productsToAssign.length);
      try {
        setLoading(true);
        const { status, response } = await patientsServices.assignProduct({
          token: authState.user.token,
          data: {
            rut,
            firstName,
            lastName,
            email,
            doctor_indications: indications,
            // phone: `+56${phone}`,
            phone: `${phone ? `+56${phone}` : ``}`,
            doctorId: authState.user.doctor._id,
            products: productsToAssign,
          },
        });
        // console.log({ status, response });
        setLoading(false);
        setModalName(modals[2]);
        if (status === 200) {
          setModal(!modal);
          if (response.error) {
            setModalError(true);
            setModalMessage(response.error.message);

            return;
          }
          setModalMessage(response.message);
        } else if (status === 401) {
          signOut();
        }
      } catch (e) {
        setLoading(false);
      }
    }
  };

  const productsContext = {
    products,
    addProducts: async (productsToAdd) => {
      //  console.log("productsToAdd", productsToAdd);
      if (productsToAdd.length) {
        //let aux = products;
        await productsToAdd.forEach((toAdd) => {
          dispatch({ type: "updateIsSelect", value: toAdd });
        });
      }
      // console.log({products})
      setModalName(modals[0]);
    },
    deleteProduct: async (product) => {
      dispatch({ type: "updateIsSelect", value: product });
      dispatch({ type: "updateQuantity", value: product, quantity: 1 });
    },
    updateQuantity: async (product, quantity) => {
      //console.log({product, quantity})
      dispatch({ type: "updateQuantity", value: product, quantity });
    },
  };

  return (
    <Grid container>
      {loading && <Loader loading={true} />}
      <Grid container className={classes.container} onScroll={onScroll}>
        <Collapse
          in={!matchesDesktop ? !paperGrow : true}
          id={"collapseId"}
          timeout={500}
          style={{ width: "100%" }}
        >
          <Grid container className={classes.headerContainer}>
            <Grid
              item
              md={2}
              xs={6}
              container
              justify="center"
              alignItems="center"
            >
              <img
                src="../../assets/asignar-muestra.svg"
                alt=""
                style={{ width: matchesDesktop ? "100%" : "60%" }} // Cambiar el ancho en dispositivos más pequeños
              />
            </Grid>
            {
              <Grid
                item
                md={10}
                container
                className={classes.desktopHeader}
                alignItems="center"
              >
                <Grid item md={2} lg={1}>
                  <IconButton
                    style={{ padding: 0 }}
                    onClick={() => history.goBack()}
                  >
                    <ArrowBackIcon />
                  </IconButton>
                </Grid>
                <Grid item md={10} lg={11}>
                  <Typography
                    style={{ fontWeight: "600" }}
                    component="h1"
                    variant="h1"
                  >
                    Asignar a
                  </Typography>
                </Grid>
                <Grid item md={12}>
                  <Typography
                    component="h1"
                    variant="h1"
                    style={{
                      fontSize: "1rem",
                      lineHeight: "1rem",
                      margin: "20px 0 0 0",
                    }}
                  >
                    Dr. Informe los datos del paciente al cual debemos entregar
                    los productos
                  </Typography>
                </Grid>
              </Grid>
            }
          </Grid>
        </Collapse>
        <Paper className={classes.paperClass}>
          <Grid
            item
            md={12}
            xs={12}
            className={classes.paperTitle}
            id="paperTitle"
          >
            <Typography component="h1" variant="h1" align="center">
              Dr. Informe los datos del paciente <br /> al cual debemos entregar
              los productos
            </Typography>
          </Grid>
          <RootRef rootRef={domRef}>
            <Grid
              container
              className={classes.containerForm} /*onScroll={onScroll}*/
            >
              <Grid
                container
                className={classes.form}
                spacing={matchesDesktop ? 4 : 2}
              >
                <Grid item xs={12} md={12}>
                  <TextField
                    containerStyle={{}}
                    name={"rut"}
                    onChange={(e) => setRut(e.target.value)}
                    placeholder="Rut *"
                    value={rut}
                    onBlur={() => onBlur("rut", rut)}
                    error={errors.rut && errors.rut.isInvalid}
                    helperText={errors.rut ? errors.rut.message : ""}
                  />
                </Grid>
                {/* <Grid item xs={12} md={6}>
                  <TextField
                    containerStyle={{}}
                    name={"name"}
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    placeholder="Nombre *"
                    onBlur={() => onBlur("firstName", firstName)}
                    error={errors.firstName && errors.firstName.isInvalid}
                    helperText={errors.firstName ? errors.firstName.message : ""}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    containerStyle={{}}
                    name={"lastName"}
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    placeholder="Apellidos *"
                    onBlur={() => onBlur("lastName", lastName)}
                    error={errors.lastName && errors.lastName.isInvalid}
                    helperText={errors.lastName ? errors.lastName.message : ""}
                  />
                </Grid> */}

                <Grid item xs={12} md={12}>
                  <TextField
                    containerStyle={{}}
                    name={"name"}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Nombre Completo"
                    onBlur={() => onBlur("name", name)}
                    error={
                      (errors.name && errors.name.isInvalid) ||
                      (errors.firstName && errors.firstName.isInvalid) ||
                      (errors.lastName && errors.lastName.isInvalid)
                    }
                    helperText={
                      (errors.name ? errors.name.message : "") ||
                      (errors.firstName ? errors.firstName.message : "") ||
                      (errors.lastName ? errors.lastName.message : "")
                    }
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                  <TextField
                    containerStyle={{}}
                    name={"email"}
                    value={email}
                    onChange={(e) =>
                      setEmail(e.target.value.replace(/\s/g, ""))
                    }
                    placeholder="Correo "
                    onBlur={() => onBlur("email", email)}
                    error={errors.email && errors.email.isInvalid}
                    helperText={errors.email ? errors.email.message : ""}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextField
                    className={classes.phoneInput}
                    name={"phone"}
                    value={phone}
                    onChange={(e) => {
                      const newPhoneValue = e.target.value;
                      if (!/^([0-9])*$/.test(newPhoneValue)) return;
                      if (newPhoneValue.length > 9) return;
                      setPhone(newPhoneValue);
                    }}
                    placeholder="Teléfono "
                    error={errors.phone && errors.phone.isInvalid}
                    helperText={errors.phone ? errors.phone.message : ""}
                    startAdornment={
                      <InputAdornment position="start">+56</InputAdornment>
                    }
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <TextField
                    containerStyle={{}}
                    multiline
                    rows={3}
                    name={"indications"}
                    value={indications}
                    onChange={(e) => setIndications(e.target.value)}
                    placeholder="Indicaciones "
                  />
                </Grid>
              </Grid>
              <Grid
                container
                spacing={matchesDesktop ? 4 : 2}
                className={classes.buttonsContainer}
                justify="center"
              >
                {/* <Grid item xs={7} md={6}
                  <OptionCard
                    option={"RESUMEN DE MUESTRA"}
                    products={products}
                    mini
                    onClick={() => {
                      setModalName(modals[0]);
                      setModal(!modal);
                    }}
                  />
                </Grid> */}
                {/* <Grid
                  item
                  xs={5}
                  md={6}
                  className={classes.containerMiniButton}
                >
                  <Button
                    onClick={() => {
                      setModalName(modals[1]);
                      setModal(!modal);
                    }}
                  >
                    {" "}
                    <AddIcon
                      color="#FFF"
                      style={{ margin: matchesDesktop ? "0 10px 0 0" : 0 }}
                    />{" "}
                    {matchesDesktop ? "AGREGAR MUESTRAS A LA LISTA" : "AGREGAR"}
                  </Button>
                </Grid> */}
                {datatermsAndCond.length > 0 && (
                  <Grid item xs={12}>
                    <Box display={"flex"} style={{ flexDirection: "column" }}>
                      <Box
                        display={"flex"}
                        style={{ gap: 4, alignItems: "center" }}
                      >
                        <Checkbox
                          id="terms-and-conditions"
                          checked={termsAndCond}
                          onChange={(e) => setTermsAndCond(e.target.checked)}
                        />
                        <Typography
                          component={"label"}
                          htmlFor="terms-and-conditions"
                        >
                          Acepto los{" "}
                          <Typography
                            component={"span"}
                            color="secondary"
                            onClick={(e) => {
                              e.preventDefault();
                              setViewTermsAndConds((prev) => !prev);
                            }}
                          >
                            Términos y condiciones
                          </Typography>
                        </Typography>
                      </Box>
                      <Collapse in={viewTermsAndConds}>
                        <List style={{ padding: 0 }}>
                          {datatermsAndCond.map((termAndCond) => (
                            <ListItem
                              key={termAndCond._id}
                              style={{ padding: "0 40px" }}
                            >
                              <Typography
                                component={"a"}
                                href={termAndCond.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                color="textPrimary"
                                style={{
                                  textDecoration: "none",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {termAndCond.name}{" "}
                                <Icon style={{ lineHeight: 0 }} color="action">
                                  <KeyboardArrowRightRoundedIcon />
                                </Icon>
                              </Typography>
                            </ListItem>
                          ))}
                        </List>
                      </Collapse>
                    </Box>
                  </Grid>
                )}
                <Grid item xs={12} container className={classes.containerBtn}>
                  <Button
                    fullWidth
                    onClick={onSubmit}
                    disabled={!termsAndCond && datatermsAndCond.length > 0}
                  >
                    Asignar a paciente
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </RootRef>
        </Paper>
      </Grid>

      <ProductsContext.Provider value={productsContext}>
        <PopUp
          modalName={modalName}
          open={modal}
          productsList={products}
          setModal={() => setModal(!modal)}
          setModalName={(name) => setModalName(name)}
          message={modalMessage}
          modalError={modalError}
          popToTop="/"
          modalSubMessage={`Dr(a) ya avisamos a ${firstName} ${lastName} que usted le envió ${quantityToAssign} ${
            quantityToAssign > 1 ? "muestras" : "muestra"
          }. Acompañe en el historial el status de la entrega.`}
        />
      </ProductsContext.Provider>
    </Grid>
  );
}

const useStyles = ({ paperGrow, titleHeight, collapseH, ...props }) =>
  makeStyles((theme) => ({
    headerContainer: {
      justifyContent: "center",
      alignItems: "flex-start",
      padding: "5px 25px 9px 45px",
      [theme.breakpoints.up("md")]: {
        justifyContent: "flex-start",
      },
    },
    paperClass: {
      //height: "calc(100% - 130px)", //"100%",
      [theme.breakpoints.up("md")]: {
        height: `calc(100% - ${collapseH}px)`,
      },
    },
    paperTitle: {
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    containerForm: {
      //height: 400, // `calc(100% - ${titleHeight}px)`,
      overflowY: "scroll",
      display: "block",
      paddingTop: 0,
      [theme.breakpoints.up("md")]: {
        height: "fit-content",
        overflowY: "unset",
      },
    },
    container: {
      display: "block",
      height: "100%",
      '@supports (height: 100dvh)': {
        height: '100dvh',
      },
      overflowY: "scroll",
      padding: "0 0 calc(100px + env(safe-area-inset-bottom, 0px)) 0",
      [theme.breakpoints.up("md")]: {
        padding: "50px 50px 0 50px",
      },
    },
    containerBtn: {
      //position: "fixed",
      bottom: 90,
      padding: "0 12px",
      //display: "none",
      "& button.Mui-disabled": {
        backgroundColor: theme.palette.grey[300],
      },
      // [theme.breakpoints.up("md")]: {
      //   position: "unset",
      // },
    },
    form: {
      margin: "0 0 20px 0",
      width: "100%",
      [theme.breakpoints.up("md")]: {
        margin: 0,
      },
    },
    containerMiniButton: {
      "& button": {
        height: "100%",
        padding: "0 18px",
        fontSize: "0.813rem",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        [theme.breakpoints.up("md")]: {
          justifyContent: "flex-start",
        },
      },
    },
    btnModal: {
      height: 40,
      justifyContent: "space-evenly",
      position: "fixed",
      width: "80%",
      bottom: 150,
    },
    paperModal: {
      position: "absolute",
      width: "90%",
      overflowY: "scroll",
      height: "90%",
      backgroundColor: "#FFF",
      boxShadow: theme.shadows[5],
      borderRadius: "45px",
      padding: "12px",
      outline: "none",
    },
    modalTitle: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      padding: "25px 13px 0 13px",
      "& button": {
        padding: 0,
      },
    },
    desktopHeader: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
        width: "85%",
        padding: "0 40px",
      },
    },
    buttonsContainer: {
      margin: "0 0 10px 0",
      width: "100%",
      [theme.breakpoints.up("md")]: {
        margin: 0,
      },
    },
    phoneInput: {
      "& .MuiInputAdornment-root": {
        "& p": {
          color: "inherit",
          font: "inherit",
        },
      },
    },
  }));
